import { useTranslation } from 'react-i18next';
import { formatIntNumber } from '@anytag/shared-utils';
import { RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_JOINED_CAMPAIGNS, MAX_JOINED_CAMPAIGNS, MIN_MAX_JOINED_CAMPAIGN_OPTIONS } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const CampaignJoinedField = () => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      options={MIN_MAX_JOINED_CAMPAIGN_OPTIONS}
      title={t('Number of campaigns participated')}
      slideProps={{ step: 1, min: MIN_JOINED_CAMPAIGNS, max: MAX_JOINED_CAMPAIGNS }}
      minField={{ name: 'minCampaignsJoined', placeholder: formatIntNumber(MIN_JOINED_CAMPAIGNS) }}
      maxField={{ name: 'maxCampaignsJoined', placeholder: `${formatIntNumber(MAX_JOINED_CAMPAIGNS)}+` }}
    />
  );
};
